import apiFetch from '../apiFetch'

export default function (token, chargeIdParent, documentId, storageDocumentId) {
  return apiFetch({ endPoint: `DocumentChargeInfo/infoParent?chargeIdParent=${chargeIdParent}&documentId=${documentId}&storageDocumentId=${storageDocumentId}`, method: 'GET', body: null, token: token })
}
